import { Dropdown, type DropDownProps } from "antd";
import type { FC } from "react";

export const AppDropdown: FC<DropDownProps> = ({ ...props }) => {
  return <Dropdown {...props} />;
};
